export default __webpack_public_path__ + "static/media/banner-bg.e3ee59b4.png";